<template>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Filtri avanzati</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div key="modal-body" class="modal-body">
                <!-- Brands -->
                <div class="mb-1" wire:ignore>
                    <label class="form-label mb-1 text-small">Marche</label>
                    <select v-model="selectedFilters.brand" class="form-select" @change="handleFilterChange">
                        <option value="">Tutti</option>
                        <option v-for="brand in filters.brands" :key="brand.id" :value="brand.id">
                            {{ brand.name }}
                        </option>
                    </select>
                </div>

                <!-- Tags -->
                <div class="mb-1" wire:ignore>
                    <label class="form-label mb-1 text-small">Tags</label>
                    <select v-model="selectedFilters.tag" class="form-select" @change="handleFilterChange">
                        <option value="">Tutti</option>
                        <option v-for="tag in filters.tags" :key="tag.id" :value="tag.id">
                            {{ tag.name }}
                        </option>
                    </select>
                </div>

                <!-- Categories -->
                <div class="mb-1">
                    <label class="form-label mb-1 text-small">Categoria</label>
                    <select v-model="selectedFilters.category" class="form-select" @change="handleFilterChange">
                        <option value="">Tutti</option>
                        <option v-for="category in filters.categories" :key="category.id" :value="category.id">
                            {{ category.name }}
                        </option>
                    </select>
                </div>

                <!-- Altri select seguono lo stesso pattern -->

                <div class="d-flex justify-content-end gap-2 mt-3">
                    <button type="button" class="btn btn-outline-secondary" @click="resetFilters">
                        Reset
                    </button>
                    <button type="button" class="btn btn-primary" @click="handleFilterChange">
                        Applica Filtri
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            filters: {
                brands: [],
                tags: [],
                categories: [],
                wineLists: [],
                philosophies: [],
                styles: [],
                productionAreas: [],
                countries: [],
                regions: [],
                actions: [],
                collections: []
            },
            selectedFilters: {
                brand: null,
                tag: null,
                category: null,
                winelist: null,
                philosophy: null,
                style: null,
                productionArea: null,
                country: null,
                region: null,
                action: null,
                new: null,
                promotion: null,
                collection: null,
                order_by: null
            }
        }
    },

    mounted() {
        this.loadAllFilters();
    },

    methods: {
        async loadAllFilters() {
            try {
                const endpoints = {
                    brands: '/comp/filters/brands',
                    tags: '/comp/filters/tags',
                    categories: '/comp/filters/categories',
                    wineLists: '/comp/filters/wine-lists',
                    philosophies: '/comp/filters/philosophies',
                    styles: '/comp/filters/styles',
                    productionAreas: '/comp/filters/production-areas',
                    countries: '/comp/filters/countries',
                    actions: '/comp/filters/actions',
                    collections: '/comp/filters/collections'
                };

                const requests = Object.entries(endpoints).map(async ([key, url]) => {
                    const response = await axios.get(url);
                    this.filters[key] = response.data;
                });

                await Promise.all(requests);
            } catch (error) {
                console.error('Error loading filters:', error);
            }
        },

        async loadRegions(countryId) {
            if (!countryId) {
                this.filters.regions = [];
                this.selectedFilters.region = null;
                return;
            }

            try {
                const response = await axios.get(`/api/filters/regions/${countryId}`);
                this.filters.regions = response.data;
            } catch (error) {
                console.error('Error loading regions:', error);
            }
        },

        handleFilterChange() {
            // Crea un oggetto con solo i filtri che hanno un valore
            const activeFilters = Object.entries(this.selectedFilters)
                .reduce((acc, [key, value]) => {
                    // Se il valore è un oggetto (es: {id: 1, name: "Test"})
                    if (value && typeof value === 'object') {
                        acc[`${key}_id`] = value.id;
                        acc[`${key}_name`] = value.name;
                    }
                    // Se il valore è una stringa o numero e non è vuoto
                    else if (value !== null && value !== '' && value !== undefined) {
                        acc[key] = value;
                    }
                    return acc;
                }, {});

            // Salva solo se ci sono filtri attivi
            if (Object.keys(activeFilters).length > 0) {
                localStorage.setItem('productFilters', JSON.stringify({
                    filters: activeFilters,
                    timestamp: new Date().toISOString(),
                    user: '{{ Auth::id() }}'
                }));
            } else {
                // Se non ci sono filtri attivi, rimuovi dal localStorage
                localStorage.removeItem('productFilters');
            }

            // Emetti l'evento al componente padre
            this.$emit('filters-updated', activeFilters);
        },

        resetFilters() {
            this.selectedFilters = {
                brand: null,
                tag: null,
                category: null,
                winelist: null,
                philosophy: null,
                style: null,
                productionArea: null,
                country: null,
                region: null,
                action: null,
                new: null,
                promotion: null,
                collection: null,
                order_by: null
            };
            localStorage.removeItem('productFilters');
            this.$emit('filters-reset');
        }
    },

    watch: {
        'selectedFilters.country'(newValue) {
            this.loadRegions(newValue);
        }
    }
}
</script>